export const commaSeperator = (x) => {
  const twoDecimal = (Math.round(x * 100) / 100).toFixed(2);
  const parts = twoDecimal.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};
